export default "__VITE_ASSET__BPmyM5M2__"